import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-by-layout',
  templateUrl: './by-layout.component.html',
})
export class ByLayoutComponent {
  constructor(
    private titleService: Title) {
    this.titleService.setTitle('BusyFly - аренда самокатов и велосипедов в твоем городе');
  }
}
